import { MSystemGet } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { startOfMonth } from "services/DateService";
import { catchRestError, FileClient } from "../RestClient";

export type B010040Request = Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  shokaKbn: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  hasoYmdFrom: string;
  hasoYmdTo: string;
  b010040Status: string;
  assistantCd: string;
  sort: string[];
}>;

// Excel出力処理
export const B010040GetExcel = (props: B010040Request) => {
  return FileClient.get("b010040/get/excel", {
    params: props,
  });
};

//当月取得処理
export const B010040TogetsuYm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  await MSystemGet()
    .then((response) => {
      const firstYmd = startOfMonth(response.data.togetsuYm);
      //受注日の範囲(開始)初期設定
      methods.setValue("juchuYmdFrom", firstYmd);
      //製作日の範囲(開始)初期設定
      methods.setValue("seisakuYmdFrom", firstYmd);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("juchuYmdFrom", "");
      methods.setValue("seisakuYmdFrom", "");
    });
};
